import { render, staticRenderFns } from "./DownloadRecordList.vue?vue&type=template&id=8fe00c86&scoped=true"
import script from "./DownloadRecordList.vue?vue&type=script&lang=js"
export * from "./DownloadRecordList.vue?vue&type=script&lang=js"
import style0 from "./DownloadRecordList.vue?vue&type=style&index=0&id=8fe00c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe00c86",
  null
  
)

export default component.exports